import { LVStrings } from "@my-dld/assets/strings";
import { I8N } from "@eres/core";

export const REQ_SOURCE_DLD_WEB = 2;

export interface ProcedureCategory {
	CategoryArabicName: string;
	CategoryEnglishName: string;
	CategoryId: number;
}

export interface Procedure {
	CategoryId: number;
	ProcedureNameArabic: string;
	ProcedureNameEnglish: string;
	ProcedureId: number;
	PropertyStatus: string;
}

export interface ProcedureTransaction {
	RequestSource: number;
	WorthValueNeeded: boolean;
	procedureId: number;
	propertyId: number;
	RTOfficeParticipantId: number;
	RentValueNeeded: boolean;
	WorthValue: number;
	DLDOnlineFees: boolean;
	RentValue: number;
	Documents: ProcedureDoc[];
	Roles: Role[];
	ValidationErrors: ValidationError[];
}

export interface Role {
	RoleOrder: number;
	RoleId: number;
	RoleName: string;
	RoleNameAr: string;
	CanAdd: boolean;
	OnlyNameAdd: boolean;
	SharesNeeded: boolean;
	Parties: Party[];
}

export interface Party {
	EnglishName?: string;
	ArabicName?: string;
	Mobile?: string;
	Email?: string;
	Passport?: string;
	EID?: string;
	SharePerc?: number;
	Documents?: ProcedureDoc[];
	country?: Country;
}

export interface Country {
	CountryId: number;
	CountryNameAr: string;
	CountryNameEn: string;
	NationalityNameAr: string;
	NationalityNameEn: string;
}

export interface ProcedureDoc {
	DocumentName: string;
	DocumentNameAr: string;
	EntityDocumentId?: number;
	Path?: string;
	IsRequired?: boolean;
	doc?: ProcedureUploadDoc;
}

export interface ProcedureUploadDoc {
	identity: any;
	fileName?: string;
	fileSize?: number;
	localData?: string;
	type?: string;
	fileUrl?: string;
}

export interface ValidationError {
	ErrorNumber: number;
	ErrorMessage: string;
	ErrorMessageAr: string;
	ExceptionObject: string;
	ValidationType: number;
}

export function getPartyDocs(): ProcedureDoc[] {
	return [
		{
			DocumentName: LVStrings.emirates_id.en!,
			DocumentNameAr: LVStrings.emirates_id.ar!,
			IsRequired: true,
		},
		{
			DocumentName: LVStrings.passport.en!,
			DocumentNameAr: LVStrings.passport.ar!,
			IsRequired: true,
		},
	];
}

export interface RTRequest {
	OnlineRequestId: number;
	ProcedureNumber: number;
	ProcedureYear: number;
	ProcedureId: number;
	CreationDate: string;
	ProcedureTypeAr: string;
	ProcedureTypeEn: string;
	RequestStatusAr: string;
	RequestStatusEn: string;
	OnlineRequestStatusId: number;
	RtParticipantId: number;
	PropertyId: number;
	IsSuccess: boolean;
}

export enum RTRequestStatusId {
	ALL = 0,
	PENDING = 1,
	PICKUP = 2,
	UNDER_AUDITING = 3,
	CANCEL = 4,
	COMPLETED = 5,
}

export interface RTOffice {
	Identity: number;
	ParticipantId: number;
	CompanyNumber: string;
	NameEn: string;
	NameAr: string;
	LicenseNumber: string;
	LicenseIssueDate: string;
	LicenseExpiryDate: string;
	Phone: string;
	Fax: string;
	PoBox: string;
	Address: string;
	CompanyLogo: string;
	Latitude: number;
	Longitude: number;
	CompanyTypeId: number;
	ContactPersonNameEn: string;
	ContactPersonNameAr: string;
	ContactPersonMobile: string;
	Email: string;
	AgreementEndDate: string;
	IsCancelled: boolean;
}

export function sortByOfficeName( offices: RTOffice[] ): RTOffice[] {
	const isArabic = I8N.isRTL();
	const sortedOffices = offices.sort( ( a: RTOffice, b: RTOffice ) => {
		const aName = isArabic ? a.NameAr : a.NameEn;
		const bName = isArabic ? b.NameAr : b.NameEn;
		return aName.trim().toLowerCase().localeCompare( bName.trim().toLowerCase() );
	} );
	return sortedOffices;
}
